import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/Logo/logo.png";
import DistributorEmptyLogo from "../../Assets/Logo/distributor-empty-logo.svg";
import "./Sidebar.css";
import { distributorMenus, menus } from "../../utils/menu.routes";
import { useSelector } from "react-redux";
import Signout from "../../Assets/svg/SignOut.svg";
import swal from "sweetalert";
import _ from "lodash";
import { usePic } from "../../context/PicProvider";
import { roles } from "../../utils/helperFunction";
import icon from "../../Assets/Profile/profileicon/Icon.png";
import { adminRoles, distributorRoles } from "../../utils/constants";

function Sidebar({ isActive, removeSideBarActive }) {
  const { role } = useSelector((state) => state.AUTH);
  const {
    LoginData: {
      data: { permissions },
    },
  } = useSelector((state) => state.LOGIN);
  const location = useLocation();
  const { handleLogout } = usePic();
  const { userData } = useSelector((state) => state.AUTH);
  const getRoleText = (role) => {
    const roleMapping = {
      [roles.rm_super_admin]: "Reliance Super Admin",
      [roles.rm_admin]: "Reliance Admin",
      [roles.admin]: "Admin",
      [roles.approver]: "Approver",
      [roles.user]: "User",
      [roles.superadmin]: "Super Admin",
      [roles.sales_representative]: "Sales Executive",
      [roles.distributor_super_admin]: "Distributor Super Admin",
      [roles.distributor_user]: "Distributor User",
    };

    return roleMapping[role] || "";
  };

  const activeClass = (activeFor) => {
    return activeFor.some(
      (route) =>
        location.pathname === route || location.pathname.startsWith(route + "/")
    )
      ? "active-menu"
      : "";
  };

  const logoutHandler = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to log out?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: true,
          closeModal: true,
          className: "swal-button--red",
        },
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          closeModal: true,
          className: "swal-button--green",
        },
      },
      dangerMode: true,
    }).then((willLogout) => {
      if (willLogout) {
        handleLogout();
      }
    });
    setTimeout(() => {
      document.activeElement.blur();
    }, 0);
  };

  const renderSidebarWithRole = (role) => {
    const dashboardMenu = menus?.slice(0, 1);
    const businessMenu = _.filter(menus?.slice(1, 6), (item) =>
      _.some(item.permission, (permission) => permissions.includes(permission))
    );
    const utilMenu = _.filter(menus?.slice(6), (item) =>
      _.some(item.permission, (permission) => permissions.includes(permission))
    );

    const distributorDashboardMenu = distributorMenus?.slice(0, 1);
    const distributorBusinessMenu = _.filter(
      distributorMenus?.slice(1, 4),
      (item) =>
        _.some(item.permission, (permission) =>
          permissions.includes(permission)
        )
    );
    // const distributorUtilMenu = _.filter(distributorMenus?.slice(4), (item) =>
    //   _.some(item.permission, (permission) => permissions.includes(permission))
    // );

    if (adminRoles.includes(role)) {
      return (
        <div className="adminmenu">
          <ul className="nav-links">
            {dashboardMenu.map((menu, i) => {
              return (
                <li key={i}>
                  <Link
                    className={activeClass(menu.activeFor)}
                    to={menu.link}
                    onClick={removeSideBarActive}
                  >
                    {menu.icon}
                    {menu.title}
                  </Link>
                </li>
              );
            })}
          </ul>
          <div className="custom-div">
            <p className="sub-heading">BUSINESS SERVICES</p>
            <ul className="nav-links">
              {businessMenu.map((menu, i) => {
                return (
                  <li key={i}>
                    <Link
                      className={`${activeClass(menu.activeFor)}`}
                      to={menu.link}
                      onClick={removeSideBarActive}
                    >
                      {menu.icon}
                      {menu.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="custom-div">
            <p className="sub-heading">UTILITIES</p>
            <ul className="nav-links">
              {utilMenu.map((menu, i) => {
                return (
                  <li key={i}>
                    <Link
                      className={`${activeClass(menu.activeFor)}`}
                      to={menu.link}
                      onClick={removeSideBarActive}
                    >
                      {menu.icon}
                      {menu.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      );
    } else if (distributorRoles.includes(role)) {
      return (
        <div>
          <ul className="nav-links">
            {distributorDashboardMenu.map((menu, i) => {
              return (
                <li key={i}>
                  <Link
                    className={activeClass(menu.activeFor)}
                    to={menu.link}
                    onClick={removeSideBarActive}
                  >
                    {menu.icon}
                    {menu.title}
                  </Link>
                </li>
              );
            })}
          </ul>
          <div className="divider"></div>
          <div className="custom-div">
            <p className="sub-heading">BUSINESS SERVICES</p>
            <ul className="nav-links">
              {distributorBusinessMenu.map((menu, i) => {
                return (
                  <li key={i}>
                    <Link
                      className={`${activeClass(menu.activeFor)}`}
                      to={menu.link}
                      onClick={removeSideBarActive}
                    >
                      {menu.icon}
                      {menu.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <div className="custom-div mb-0">
            <p className="sub-heading">UTILITIES</p>
            <ul className="nav-links">
              {distributorUtilMenu.map((menu, i) => {
                return (
                  <li key={i}>
                    <Link
                      className={`${activeClass(menu.activeFor)}`}
                      to={menu.link}
                      onClick={removeSideBarActive}
                    >
                      {menu.icon}
                      {menu.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div> */}
        </div>
      );
    }
  };

  return (
    <div className={isActive ? "sidebar active" : "sidebar"}>
      {adminRoles.includes(role) && (
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
      )}
      {distributorRoles.includes(role) &&
        (userData?.company_white_logo ? (
          <div className="logo">
            <img src={userData?.company_white_logo} alt="Logo" />
          </div>
        ) : (
          <div className="logo">
            <img src={DistributorEmptyLogo} alt="Logo" />
          </div>
        ))}
      <div
        className="d-none d-lg-flex justify-content-center align-items-center gap-2"
        style={{
          paddingBottom: 20,
          borderBottom: "1px solid #f1f1f4",
          marginBottom: 28,
        }}
      >
        {userData && (
          <img
            src={userData?.company_logo ? userData.company_logo : icon}
            alt="Profile"
            className="profile-pic"
            onError={(e) => {
              e.target.src = icon;
            }}
          />
        )}
        <div>
          <span className="admin-name">
            {userData &&
              `${userData.first_name} ${
                userData.last_name ? userData.last_name : ""
              }`}
          </span>
          <span className="superadmin-name">
            {userData && getRoleText(userData.assigned_role)}
          </span>
        </div>
      </div>
      <div className="navigation d-flex flex-column justify-content-between">
        {renderSidebarWithRole(role)}
        <div
          className="logout d-flex align-items-center gap-2"
          onClick={logoutHandler}
        >
          <img src={Signout} alt="Signout icon" />
          Log Out
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
